export const GENERATION_STATUSES = ['queued', 'running', 'succeeded', 'failed', 'recovery_required'] as const;
export type GenerationStatus = typeof GENERATION_STATUSES[number];
export interface GenerationJob {
  id: string; source: 'cli' | 'api'; status: GenerationStatus; phase: string; percent: number; stage: string;
  completed: number | null; total: number | null; created_at: string; updated_at: string;
  started_at: string | null; finished_at: string | null; source_revision: string | null;
  candidate_version: string | null; publication_owner: string | null; barrier: boolean;
  error_code: 'generation_failed' | 'publication_uncertain' | null;
}
export interface GenerationParams { page: number; per_page: number; status?: GenerationStatus; sort: 'created_at' | '-created_at' }
export interface GenerationPage { items: GenerationJob[]; meta: { page: number; per_page: number; total: number; page_count: number } }
export interface PublishedMapSummary {
  version: string; geometry_revision: string | null; tile_index: boolean;
  manifest: { format: number; tile_count: number; overview_max_zoom: number; exact_min_zoom: number; zone_min_zoom: number; zone_count: number; region_count: number };
}
export const GENERATION_POLL_MS = 3000;
export function isGenerationActive(job: GenerationJob): boolean { return job.status === 'queued' || job.status === 'running'; }
export function isGenerationBlocking(job: GenerationJob): boolean { return isGenerationActive(job) || job.status === 'recovery_required'; }
